import axios from 'axios'
import { Message } from 'element-ui'
import store from '../store'
import * as Sentry from '@sentry/browser'

const service = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 15000
})

const isHtml = (item) => {
  return /<\/?[a-z][\s\S]*>/i.test(item)
}

// request
service.interceptors.request.use(config => {
  if (config.url === '/auth/local' || config.url === '/auth/forgot-password') {
    return config
  } else {
    if (store.getters.token) {
      config.headers['Authorization'] = 'Bearer ' + store.getters.token
    }
    return config
  }
}, error => {
  // Do something with request error
  // console.log(error) // for debug
  Promise.reject(error)
})

// response
service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    // console.error('err response' + JSON.stringify(error.response.data))// for debug
    // console.log('err response' + JSON.stringify(error.response.data.message[0]))// for debug
    Sentry.captureException(error.response.data) // for debug
    var errorMessage = ''
    var showErrorMessage = true

    try {
      if (isHtml(error.response.data)) {
        errorMessage = 'Undefined error'
        showErrorMessage = false
      } else if (error.response.data.message) {
        if (error.response.data.message[0].messages.length > 0) {
          errorMessage = error.response.data.message[0].messages[0].message
        } else {
          errorMessage = error.response.data.message
        }
      } else if (error.response.data.error) {
        errorMessage = error.response.data.error
      } else {
        error.response.data
      }
    } catch (error) {
      errorMessage = 'Oops! Something went wrong. It could be you are not authorized to perform this action.'
    }

    if (showErrorMessage) {
      Message({
        message: errorMessage,
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(errorMessage)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js